/**
 * The currency label shown next to amounts.
 *
 * Odoo installs keep the labels each screen was written with ('LE', 'ج.م'),
 * exactly as before. SellGo's own database knows the company's currency, so
 * there the company's symbol (ر.س, ج.م, …) is shown instead: it is read at
 * sign-in and when the app opens (companySetup.js), and saved.
 */
import { getBackend } from '@/api/apiClient';

const LS_SYMBOL = 'sellgo_currency_symbol';

let symbol = null;
try {
  symbol = localStorage.getItem(LS_SYMBOL);
} catch {
  // storage blocked: the screens' own labels show until the company is read
}

/** The company's currency symbol on SellGo's own database; `odooLabel` on Odoo. */
export function cur(odooLabel = 'LE') {
  return symbol && getBackend() === 'supabase' ? symbol : odooLabel;
}

export function setCurrencySymbol(value) {
  symbol = value || null;
  try {
    if (symbol) localStorage.setItem(LS_SYMBOL, symbol);
    else localStorage.removeItem(LS_SYMBOL);
  } catch {
    // kept for this session only
  }
}
